import { Analytics } from './analytics'
import { FacebookLogger } from './facebook'
export const dbiAnalytics = new Analytics()
export const facebookAnalytics = new FacebookLogger()